import gql from 'graphql-tag';
import React from 'react'
import {hooks} from 'lib.front';
import { useDispatch } from 'react-redux';
import { loadingModal, logVerificar, openMsg } from 'src/redux-app';
import { clientLog } from 'src/common/gqlClientes';


const verificarQ = gql`
   {
      verificarCrm {
         codigo
         nombre
         apPaterno
         apMaterno
         usuario
         email
         condicion
         sucursal
         especialidad
      }
   }
`;

export default function useVerificar() {
    //REDUX 
    const dispatch = useDispatch();
    //CALLBACKS LOGIN
    function callbackProcesarData(data) {
        dispatch(logVerificar(data.verificarCrm));
    }

    function callbackLoading(loading) {
        dispatch(loadingModal(loading));
    }

    function callbackError(error) {
        dispatch(openMsg(JSON.stringify(error)));
        dispatch(logVerificar({}));
    }

    const [verificarCall] = hooks.useApolloLazyQ(
        verificarQ,
        {
            callbackProcesarData,
            callbackLoading,
            callbackError
        },
        {
            client: clientLog
        }
    );
  return verificarCall;
}
